import { Clausula } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Clausula>('clausulas');
